import * as AccreditationActions from '../accreditation.actions'
import { IDS } from '../accreditation-action-id.constants'
/**
 * Creates a new AddSchemeController.
 * @class
 */
class AddSchemeController {
    constructor($ngRedux, $state, $scope, Notifier, NavigationActions) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.Notifier           = Notifier;
        this.NavigationActions  = NavigationActions;
    }

    $onInit() {
        this.identifier = IDS.addRegulatoryFramework;
        this.unsubscribe = this.$ngRedux.connect(
            state => {
                return {
                    frameworkDetails: state.accreditation[this.identifier],
                }
            },
            {
                ...AccreditationActions,
            }
        )(this);
    }

    onSubmit() {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.detailsForm');
        if (this.detailsForm.$valid) {
            let module_prefixes;
            if (this.frameworkDetails.module_prefixes_text && this.frameworkDetails.module_prefixes_text.replace(/[^a-z0-9]/gi, '').length) {
                module_prefixes = this.frameworkDetails.module_prefixes_text.split(',').map(item => item.replace(/[^a-z0-9]/gi, '')).filter(item => item);
            }
            const data = {
                ...this.frameworkDetails,
                module_prefixes,
                module_prefixes_text: undefined,
                leadingZerosOptions: undefined,
                leadingZerosOptions3rdLevel: undefined,

            }
            this.addRegulatoryFramework(data, this.NavigationActions.getConfigs, this.$state);
        }
        else
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

AddSchemeController.$inject = ['$ngRedux', '$state', '$scope', 'Notifier', 'NavigationActions']

export const addRegulatoryFramework = {
    controller: AddSchemeController,

    template: `
        <tabs-header title="{{'ACCREDITATION.ADD_SCHEME.TITLE' | translate}}"></tabs-header>
        
        <form id="detailsForm" name="$ctrl.detailsForm" noValidate>
            <div layout-gt-xs="row">
                <input-text flex-gt-md="60"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.SETTINGS.SCHEME.TILE_CODE' | translate}}"
                    name="code"
                    state-path="code"
                    required="true"
                    max-length="16"></input-text>
            </div>
            <div layout-gt-xs="row">
                <input-text-area flex class="noMarginBottom"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.SETTINGS.SCHEME.TILE_NAME' | translate}}"
                    name="name"
                    state-path="name"
                    required="true"
                    rows="1"
                    max-length="45"></input-text-area>
            </div>
            <div layout-gt-md="row">
                <input-text-area flex class="noMarginBottom"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.SETTINGS.SCHEME.NAME' | translate}}"
                    name="description"
                    state-path="description"
                    required="true"
                    rows="2"
                    max-length="120"></input-text-area>
            </div>    
            <div layout-gt-xs="row">
                <input-text flex-gt-md="60" 
                            label="{{'ACCREDITATION.SETTINGS.SCHEME.VERSION' | translate}}" 
                            name="version" identifier="{{$ctrl.identifier}}" 
                            state-path="version" 
                            max-length="45">
                </input-text>
            </div>
            <div layout-gt-xs="row">
                <input-text flex-gt-md="60" 
                            label="{{'ACCREDITATION.SETTINGS.SCHEME.MODULE_PREFIXES' | translate}}" 
                            name="version" identifier="{{$ctrl.identifier}}" 
                            state-path="module_prefixes_text" 
                            max-length="45">
                </input-text>
            </div>
            <h4>{{'ACCREDITATION.SETTINGS.SCHEME.DIGITS_HEADER' | translate}}</h4>
            <div layout-gt-xs="row">
                <input-select flex-gt-md="10"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.SETTINGS.SCHEME.CATEGORY' | translate}}"
                    name="level1_num_format"
                    state-path="level1_num_format"
                    state-data="leadingZerosOptions"
            ></input-select>
                <input-select flex-gt-md="10"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                    name="level2_num_format"
                    state-path="level2_num_format"
                    state-data="leadingZerosOptions"
            ></input-select>
                <input-select flex-gt-md="10"
                    identifier="{{$ctrl.identifier}}"
                    label="{{'ACCREDITATION.SETTINGS.SCHEME.ACTIVITY' | translate}}"
                    name="level3_num_format"
                    state-path="level3_num_format"
                    state-data="leadingZerosOptions3rdLevel"
            ></input-select>
            </div>
<!--            <div>{{$ctrl.categoryNumber.padStart(parseInt($ctrl.categoryLeadingZeros), '0')}}</div>-->
<!--            <div style="color: #7b7b7b">{{'Example: '+$ctrl.categoryNumber+'.'+$ctrl.sectionNumber+'.'+$ctrl.activityNumber}}</div>-->
            
            <div layout-xs="column"
                layout-sm="column"
                layout-gt-sm="row"
                flex-gt-md="60"
                layout-align="center center">
                    <div flex hide-xs hide-sm></div>
                    <md-button class="btnColorAccreditations" 
                        name="btnSubmit" 
                        aria-label="Add Scheme" 
                        ng-click="$ctrl.onSubmit()">{{'COMMON.BUTTON.ADD'| translate}}</md-button>
            </div>
        </form>`
}
